module.exports = __webpack_public_path__ + "img/custom-item1-5.2c0ca98.png";